import React from "react";
import { useTranslation, useLocale } from "./contexts/LocaleContext";
import { useNavigate } from "react-router-dom";
import { LandingNav } from "./LandingPage";

export default function TermsOfService() {
  const t = useTranslation();
  const { locale } = useLocale();
  const navigate = useNavigate();

  // Remove dark class on terms page - it has its own dark styling
  React.useEffect(() => {
    const root = window.document.documentElement;
    root.classList.remove("dark");

    return () => {
      // Restore theme when leaving terms page
      const savedTheme = localStorage.getItem("theme");
      if (savedTheme === "dark") {
        root.classList.add("dark");
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-950 via-slate-950 to-black text-white">
      <LandingNav />
      <div className="max-w-4xl mx-auto px-4 py-12 md:py-16">
        <button
          onClick={() => navigate(locale === 'cs' ? "/" : `/${locale}`)}
          className="mb-8 text-purple-300 hover:text-purple-200 transition-colors bg-transparent border-0 cursor-pointer flex items-center gap-2"
        >
          <svg
            className="w-5 h-5"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M10 19l-7-7m0 0l7-7m-7 7h18"
            />
          </svg>
          {t.common.backToHome}
        </button>

        <h1 className="text-4xl md:text-5xl font-bold mb-8">{t.terms.title}</h1>

        <div className="prose prose-invert max-w-none space-y-8 text-slate-300">
          {t.terms.sections.map((section, index) => (
            <section key={index}>
              <h2 className="text-2xl font-semibold text-white mb-4">
                {section.title}
              </h2>
              {index === 0 ? (
                <>
                  <p className="mb-4">{section.paragraphs?.[0]}</p>
                  <div className="bg-slate-900/50 p-6 rounded-lg mb-4 border border-purple-500/20 shadow-lg">
                    {section.paragraphs
                      ?.slice(1, -1)
                      .map((paragraph, pIndex) => (
                        <p key={pIndex} className="mb-2 last:mb-0">
                          {paragraph}
                        </p>
                      ))}
                  </div>
                  <p className="mb-3">
                    {section.paragraphs?.[section.paragraphs.length - 1]}
                  </p>
                </>
              ) : (
                section.paragraphs?.map((paragraph, pIndex) => (
                  <p key={pIndex} className="mb-3">
                    {paragraph}
                  </p>
                ))
              )}
              {section.list && (
                <ul className="list-disc list-inside mb-4 space-y-2 ml-4">
                  {section.list.map((item, itemIndex) => (
                    <li key={itemIndex}>{item}</li>
                  ))}
                </ul>
              )}
              {section.paragraphsAfterList?.map((paragraph, pIndex) => (
                <p key={pIndex} className="mb-3">
                  {paragraph}
                </p>
              ))}
              {section.subsections?.map((subsection, subIndex) => (
                <div key={subIndex} className="mt-4">
                  <h3 className="text-xl font-semibold text-white mb-3">
                    {subsection.title}
                  </h3>
                  {subsection.paragraphs?.map((paragraph, pIndex) => (
                    <p key={pIndex} className="mb-3">
                      {paragraph}
                    </p>
                  ))}
                </div>
              ))}
            </section>
          ))}
        </div>
      </div>
    </div>
  );
}
